import { useEffect } from 'react';
import { ThemeProvider } from '@mui/material';
import { theme } from './styles/theme';
import { BrowserRouter, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { ptBR } from '@mui/x-date-pickers/locales';
import moment from 'moment';
import 'react-toastify/dist/ReactToastify.css';
import 'moment/locale/pt-br';
import Routes from './routes';
import { AuthProvider } from './context/auth';
import { RegisterProvider } from './context/register';
import { registerPushNotification } from './components/notification/modal';
import { ModalError } from './components/error';

moment.locale('pt-br')

function App() {

	useEffect(() => {
		const registered = localStorage.getItem('deviceId')
		if (registered) {
			registerPushNotification()
		}
	}, [])

	return (
		<AuthProvider>
			<RegisterProvider>
				<BrowserRouter>
					<RouteChangeWatcher />
					<LocalizationProvider
						dateAdapter={AdapterMoment}
						adapterLocale='pt-br'
						localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}>
						<ThemeProvider theme={theme}>
							<Routes />
							<ModalError />
						</ThemeProvider>
					</LocalizationProvider>
					<ToastContainer />
				</BrowserRouter>
			</RegisterProvider>
		</AuthProvider>


	);
}

const RouteChangeWatcher = () => {
	const location = useLocation()
	const navigate = useNavigate()

	const isMobileDevice = (): boolean => {
		const userAgent = navigator.userAgent || navigator?.vendor || (window as any)?.opera

		const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|Mobile|Tablet/i
		if (mobileRegex.test(userAgent || "")) {
			return true
		}

		if ((navigator as any)?.userAgentData) {
			return (navigator as any).userAgentData.mobile ?? false
		}

		return false
	}

	useEffect(() => {
		if (!isMobileDevice()) {
			if ((location.pathname !== "/" && !location.pathname.includes("parceiro") && location.pathname !== "/redefinir-senha") && location.pathname !== "/acesso-computador") {
				const state = location.state as { path?: string };
				if (!state?.path) {
					navigate("/acesso-computador", {
						state: {
							path: location.pathname + location.search
						}
					});
				}
			}
		}
	}, [location.pathname, navigate])

	return null
}

export default App;
